import { Authenticator } from '@aws-amplify/ui-react';
import { Amplify } from 'aws-amplify';
import { Route, Routes } from 'react-router-dom';

import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

import awsExports from './aws-exports';
import NavigationScroll from './layouts/NavigationScroll';
import ProtectedLayout from './layouts/ProtectedLayout';
import PublicLayout from './layouts/PublicLayout';
import PrivateLayout from './layouts/PrivateLayout';
import Auth from './views/Auth';
import { Navigate } from 'react-router-dom';

Amplify.configure({
  ...awsExports,
});

const App = () => {
  const theme = useTheme();

  return (
    <Authenticator.Provider>
      <Container disableGutters={true} maxWidth={false}>
        <Box minHeight="100vh">
          <NavigationScroll>
            <Routes>
              <Route path="/" element={<PublicLayout/>} />
              <Route path="/public/*" element={<PublicLayout />} />
              <Route path="/app/*" element={<ProtectedLayout />} />
              {/* <Route path="/auth/" element={<Auth />} /> */}
            </Routes>
          </NavigationScroll>
        </Box>
      </Container>
    </Authenticator.Provider>
  );
};

export default App;
